import React from "react"
import PropTypes from "prop-types"
import { AnchorButton } from "gatsby-interface"
import { MdArrowForward } from "react-icons/md"
import { Integration } from "@modules/ui/components/Integration"

const cmsIntegrationRowCss = theme => ({
  borderTop: `1px solid ${theme.colors.grey[20]}`,
})

export function CmsManualIntegrationRow({ name, logoUrl, docUrl }) {
  return (
    <Integration css={cmsIntegrationRowCss} key={name}>
      <Integration.Row>
        <Integration.Vendor image={logoUrl} name={name} />

        <Integration.Actions>
          <AnchorButton
            variant={`GHOST`}
            href={docUrl}
            target="_blank"
            rightIcon={<MdArrowForward />}
            aria-label={`Setup instructions for ${name}`}
          >
            Setup instructions
          </AnchorButton>
        </Integration.Actions>
      </Integration.Row>
    </Integration>
  )
}

CmsManualIntegrationRow.propTypes = {
  name: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  docUrl: PropTypes.string.isRequired,
}
